import useAuthGetData from "../../../hooks/useAuthGetData"
import { React,useState,useEffect } from "react";

const AutoCompleteField = ({name,placeholder,id, errors, value, handleChange, isRequired, formRequired, handleSuggestion,url,filteredSuggestions,setFilteredSuggestions}) => {

    const [inputValue, setInputValue] = useState("");
    const [suggestData, setSuggestData] = useState([]);

    useEffect(()=>{
        setInputValue(value)
    },[value])

    const GetData = async (inputValue) => {
       return await useAuthGetData(url,{data:inputValue})
    }

    const HandleText = async (event) => {
        const inputValue = event.target.value;
        setInputValue(inputValue);

        if(inputValue.length === 3){
            let fetchData = await GetData(inputValue)
            let data = fetchData.status ? fetchData.data : []
            setSuggestData(data)
        }

        if(inputValue.length > 2){
            const filteredSuggestions = suggestData.filter(suggestion =>{
                    return suggestion.name.toLowerCase().includes(inputValue.toLowerCase())
                }
            );

            if(filteredSuggestions.length === 0){
                setFilteredSuggestions([]);
            }

            setFilteredSuggestions(filteredSuggestions.map(d=>d.name));
        }else{
            setFilteredSuggestions([]);
        }
    };

    const handleSelect = (value) => {
        setInputValue(value);
        handleSuggestion(value);
        setFilteredSuggestions([]);
    };

    return (
        <div className="form-group">
            <label htmlFor={id}>{placeholder} {isRequired ? '*' : ''}</label>
            {formRequired ? <div className="tt-required">* Required Fields</div> : ''}
            <div className="autocomplete-container">
                <input
                    className="autocomplete-input form-control"
                    type="text"
                    value={inputValue}
                    onChange={(e)=>{handleChange(e);HandleText(e)}}
                    placeholder={placeholder}
                    name={name}
                    autoComplete = "off"
                    id={id}
                />
                <ul className="autocomplete-suggestions">
                    {filteredSuggestions.map((suggestion, index) => (
                        <li key={index} className="autocomplete-suggestion" onClick={()=>handleSelect(suggestion)}>
                            {suggestion}
                        </li>
                    ))}
                </ul>
                <div
                    id={`${id}-error`}
                    className="invalid-feedback animated fadeInUp p-0"
                    style={{ display: "block" }}
                >
                    {errors && errors}
                </div>
            </div>

        </div>
    )

}

export default AutoCompleteField
